<div class=" margin-large-top-res"
    style="margin: 10px auto;margin-top: 40px;padding-top: 10px; width: 100%; max-width: 1200px;">
    <!-- wrap -->
    <div *ngIf="session.role.ability === 'super-admin'">
        <ul class="uk-flex-center" uk-tab>
            <li (click)="goToReservations()">
                <a href="/reservation/list">
                    RESERVATION
                </a>
            </li>
            <li class="uk-active">
                <a>
                    Clôture
                </a>
            </li>
        </ul>
    </div>

    <div class="ClotureContainer">
        <div class="dateContainer">
            <div class="menu">
                <div class="dateContainer__date background-grey">


                    <input class="inputVehiculeSearch" type="text" [(ngModel)]="search"
                        (ngModelChange)="onSearchChange($event)" placeholder="Rechercher">

                    <!-- <label>Selectionner un vehicule</label>
                    <div class="uk-form-controls uk-margin-small-top uk-position-relative">
                        <span *ngIf="loadingVehicule === false" class="uk-form-icon uk-form-icon-flip"
                            style="top: -5px;">
                            <img src="../../../assets/icons/Search.svg" width="24px" height="24px" alt="user" />
                        </span>

                        <span *ngIf="loadingVehicule === true" class="uk-form-icon uk-form-icon-flip">
                            <div style="width:24px; height: 24px;" uk-spinner></div>
                        </span>

                        <input class="inputVehiculeSearch" type="text" [(ngModel)]="vehicleSearch"
                            (ngModelChange)="updateVehicleOptionList($event)" (focusout)="toggleSuggestions(false)"
                            (focus)="toggleSuggestions(true)" placeholder="FJ-283-ZE">

                        <div [class.display-none]="vehicleDisplay === false || loadingVehicule === true"
                            class="suggestionCloture">
                            <div [class.display-none]="options.length === 0" class="arrow"></div>
                            <div [class.display-none]="noResultVehicule === false">
                                Pas de résultats
                            </div>
                            <div [class.display-none]="noResultVehicule === true" *ngFor="let option of options"
                                (click)="setVehicleSearch(option)">
                                {{ option.name }} | {{ option.brand }} {{ option.model }}
                            </div>
                        </div>
                    </div> -->
                </div>

                <div class="dateContainer__date background-grey uk-margin-small-top">
                    <label for="dateStart">Date de début</label>
                    <div class="date">
                        <input type="datetime-local" [(ngModel)]="dateStart" />
                    </div>

                    <label for="dateEnd">Date de fin</label>
                    <div class="date">
                        <input type="datetime-local" [(ngModel)]="dateEnd" />
                    </div>

                    <button class="button-small bold uk-margin-medium-top" (click)="getInfo()">
                        <span>Mettre à jour</span>
                        <img src="../../../assets/icons/Search.svg" width="32px" height="32px" alt="back"
                            class="uk-margin-left">
                    </button>
                </div>

                <div class="dateContainer__date background-red uk-margin-small-top">
                    <button class="button-small bold" (click)="clotureAdminReservation()">
                        <span>Cloture réservation Admin</span>
                        <img src="../../../assets/icons/Search.svg" width="32px" height="32px" alt="back"
                            class="uk-margin-left">
                    </button>
                </div>

            </div>
        </div>

        <div style="padding: 0.75rem;">
            <div *ngIf="loadingStatus == true" class="uk-position-center">
                <div uk-spinner></div>
            </div>


            <div class="uk-text-center regular border" *ngIf="clotures.length == 0 && (!loadingStatus)">
                <span class="title">Aucune donnée trouvé</span>
            </div>

            <div class="carsharing-list" *ngFor="let clotureElement of clotures; let i = index"
                [class.background-yellow]="clotureElement.AlertOldStatus == 6"
                [class.background-violet]="clotureElement.AlertOldStatus == 7"
                [class.background-blue]="clotureElement.AlertOldStatus == 3"
                [class.background-green]="clotureElement.AlertOldStatus == 0"
                [class.background-dark-blue]="clotureElement.AlertOldStatus == 5">
                <div class="containerReservation" style="align-items: center; gap: 20px;">

                    <div class="header">
                        <div class="header__date">
                            <div>{{ clotureElement.Start }}</div>
                            <div>{{ clotureElement.End }}</div>
                        </div>
                        <div class="header__license pointer"
                            [routerLink]="['/ressource/vehicle/informations', clotureElement.IdVehicle]"
                            [queryParams]="{from: '/carsharing/list', name: 'Cloture liste'}">
                            {{ clotureElement.LicensePlate }}
                        </div>
                        <div class="header__code pointer"
                            [routerLink]="['/reservation/informations', clotureElement.Id]"
                            [queryParams]="{from: '/carsharing/list', name: 'Cloture liste'}">
                            {{ clotureElement.BookingCode }}
                        </div>
                    </div>

                    <div class="alert">
                        <span *ngFor="let alert of clotureElement.AlertOlds; let i = index">
                            {{ alert.AlertOldName }}
                        </span>
                    </div>

                    <div class="footer">
                        <!-- uk-toggle="target: #cloture-car" -->
                        <button class="button-small" type="button" (click)="displayModal(clotureElement)">
                            <!-- data-uk-toggle="{target:'#cloture-car', param1: 'valeur1', param2: 'valeur2'}"> -->
                            <!-- (click)="getData(i, mticket.BookingCode)"> -->
                            <span>voir les informations</span>
                            <img src="../../../assets/icons/Add.svg" width="32px" height="32px" alt="back"
                                class="uk-margin-left">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-cloture-car [reservation]="actualReservation"></app-cloture-car>